<template>
  <v-fade-transition mode="out-in">
    <img class="pepe-icon" v-if="isPepe" :src="icons.pepe" alt="pepe" @click="toggleTheme" />
    <v-icon v-else :key="isDark" @click="toggleTheme">
      {{ isDark ? icons.mdiWeatherSunny : icons.mdiWeatherNight }}
    </v-icon>
  </v-fade-transition>
</template>

<script>
  import { mdiWeatherNight, mdiWeatherSunny } from "@mdi/js";
  import useAppConfig from "@core/@app-config/useAppConfig";
  import { mixpanelWrapper } from "@/@core/libs/mixpanel";
  import store from "@/store";
  import setVuetifyColorsCssVariables from "@core/utils/colors";
  import themeConfig from "@themeConfig";
  import pepe from "@/assets/images/pepe/pepe-sad.png";

  export default {
    setup() {
      const { isDark, isPepe } = useAppConfig();

      return {
        isDark,
        isPepe,
        setVuetifyColorsCssVariables,
        clicks: 0,
        themeConfig,
        clickTime: null,

        // Icons
        icons: {
          mdiWeatherNight,
          mdiWeatherSunny,
          pepe,
        },
      };
    },
    watch: {
      isPepe(val) {
        if (val) {
          this.addPepes();
        } else {
          this.removePepes();
        }
      },
    },
    mounted() {
      if (this.isPepe) {
        setTimeout(() => {
          this.addPepes();
        }, 500);
      }
    },
    methods: {
      toggleTheme() {
        this.clicks++;
        if (!this.clickTime) {
          this.clickTime = new Date();
        }
        if (new Date() - this.clickTime > 10000) {
          this.clicks = 0;
          this.clickTime = new Date();
        }
        if (this.clicks >= 10 && new Date() - this.clickTime < 10000) {
          this.isPepe = true;
          this.clicks = 0;
          this.clickTime = null;
        } else {
          this.isPepe = false;
          this.isDark = this.isDark ? false : true;
        }
        mixpanelWrapper.track("Theme Switched", { previous_page: store.getters["getPreviousRoute"] });
      },
      addPepes() {
        const wrap = document.querySelectorAll(".v-application");

        if (wrap[1]) {
          wrap[1].classList.add("pepe-background");
          document.querySelectorAll(".v-main")[1].style.zIndex = 1;
        }
      },
      removePepes() {
        const wrap = document.querySelectorAll(".v-application");

        if (wrap[1]) {
          wrap[1].classList.remove("pepe-background");
          document.querySelectorAll(".v-main")[1].style.zIndex = "";
        }
      },
    },
  };
</script>

<style>
  .pepe-icon {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }

  .pepe-background::after {
    content: " ";
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.4;
    background-image: url("~@/assets/images/pepe/pepe-beer.png");
    background-repeat: space;
    background-size: 200px;
    z-index: 0;
  }
</style>
